export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const SET_ACTIVE_ORGANIZATION = 'SET_ACTIVE_ORGANIZATION';
export const SET_PAGINATION = 'SET_PAGINATION';

// initial state
const state = {
    list: {},
    active: { country_code: '', phoneNumber: '' },
    pagination: {}
}

// getters
const getters = {
    organizations: state => state.list,
    organization: state => state.active,
    organizationPagination: state => state.pagination,
}

// actions
const actions = {

    getOrganizations: ({commit, state}, payload) => {
        axios.get(laroute.route('api.organizations.index'))
            .then((response) => {
                commit(SET_ORGANIZATION, {
                    organizations: response.data.data
                });

                if(response.data.meta) {
                    commit(SET_PAGINATION, {
                        pagination: response.data.meta
                    });
                }
            })
    },

    getMoreOrganizations: ({commit, state}, payload) => {

        axios.get(laroute.route('api.organizations.index', {page: payload.page}))
            .then((response) => {
                commit(SET_ORGANIZATION, {
                    organizations: response.data.data
                });

                commit(SET_PAGINATION, {
                    pagination: response.data.meta
                });

            })
    },

    getOrganization: ({commit, state}, payload) => {
        axios.get(laroute.route('api.organizations.show', {organization: payload.id}))
        .then((response) => {
            commit(SET_ACTIVE_ORGANIZATION, {
                active: response.data.data
            });
        })
    },

    setActiveOrganization: ({commit, state}, payload) => {
        commit(SET_ACTIVE_ORGANIZATION, {
            active: payload
        })

    }
}

// mutations
const mutations = {
    SET_ORGANIZATION: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.organizations);
    },

    SET_ACTIVE_ORGANIZATION: (state, payload) => {
        state.active = Object.assign({}, state.active, payload.active);
    },

    SET_PAGINATION: (state, payload) => {
      state.pagination = Object.assign({}, state.pagination, payload.pagination);
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
